import { render, staticRenderFns } from "./LocationLogo.vue?vue&type=template&id=32603b36&scoped=true"
import script from "./LocationLogo.vue?vue&type=script&lang=js"
export * from "./LocationLogo.vue?vue&type=script&lang=js"
import style0 from "./LocationLogo.vue?vue&type=style&index=0&id=32603b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32603b36",
  null
  
)

export default component.exports